import { HistoryOutlined } from '@ant-design/icons';
import { Button, Layout, Modal, PageHeader } from 'antd';
import { useState } from 'react';
import { CreateBackupPage } from './create-backup-page';
import { RestoreBackupPage } from './restore-backup-page';

export function BackupsPage() {
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [isRestoreModalVisible, setIsRestoreModalVisible] = useState(false);

  const { Content } = Layout;

  const closeCreateModal = () => {
    setIsCreateModalVisible(false);
  };

  const closeRestoreModal = () => {
    setIsRestoreModalVisible(false);
  };

  return (
    <>
      <PageHeader
        title={
          <>
            <HistoryOutlined /> Yedekleme
          </>
        }
      />
      <Content
        style={{
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            backgroundColor: 'white',
            gap: '2rem',
          }}
        >
          <Button
            type="primary"
            size="large"
            onClick={() => {
              setIsCreateModalVisible(true);
            }}
            style={{ width: '30%', height: '5rem' }}
          >
            Yedek dosyası oluştur
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              setIsRestoreModalVisible(true);
            }}
            style={{ width: '30%', height: '5rem' }}
          >
            Yedek dosyasından geri yükle
          </Button>
        </div>
      </Content>
      <Modal title="Yedek dosyası oluştur" visible={isCreateModalVisible} footer={null} onCancel={closeCreateModal} destroyOnClose>
        <CreateBackupPage onComplete={closeCreateModal} />
      </Modal>
      <Modal title="Yedek dosyasından geri yükle" visible={isRestoreModalVisible} footer={null} onCancel={closeRestoreModal} destroyOnClose>
        <RestoreBackupPage onComplete={closeRestoreModal} />
      </Modal>
    </>
  );
}
